<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "LaporanTataKelolaPerusahaan",

  metaInfo: { title: "Laporan Tata Kelola Perusahaan" },

  extends: View,

  mixins: [LoadSections(["hero-alt", "corporate-governance", "info"])],

  props: {
    id: {
      type: String,
      default: "corporategovernance"
    }
  }
};
</script>
